// extracted by mini-css-extract-plugin
export default {"sidebar":"PrivacyPolicy_sidebar__--dhs","active":"PrivacyPolicy_active__4Lt7F","content":"PrivacyPolicy_content__o9SFJ"};